import z from "zod";
import {
  bindExistingAccount,
  createWechatUser,
  getWechatAuthUrl,
  getWechatBindContext,
  getWechatBindStatus,
  sendLocalLoginVerificationEmail,
  sendWechatBindVerificationEmail,
  setLocalLoginForWechat,
  unbindWechat,
} from "@/lib/api/generated/endpoints/wechat-auth/wechat-auth";

const normalizeEmail = (email: string) => email.trim().toLowerCase();

export const WECHAT_BIND_STATUS_QUERY_KEY = ["wechat-bind-status"] as const;

export const setLocalLoginForWechatSchema = z
  .object({
    email: z.email("无效的邮箱").transform(normalizeEmail),
    verificationCode: z.string().min(6, "验证码长度至少为6位"),
    password: z.string().min(8, "密码长度至少为8位"),
    rePassword: z.string().min(8, "密码长度至少为8位"),
  })
  .refine((data) => data.password === data.rePassword, {
    message: "两次输入的密码不一致",
    path: ["rePassword"],
  });

export {
  bindExistingAccount,
  createWechatUser,
  getWechatAuthUrl,
  getWechatBindContext,
  getWechatBindStatus,
  sendLocalLoginVerificationEmail,
  sendWechatBindVerificationEmail,
  setLocalLoginForWechat,
  unbindWechat,
};
